import CheckmarkIcon from '@ordr-as/icons/CheckmarkIcon';
import type { ChipState } from '../types';

const CHIP_CLASSES: Record<ChipState, string> = {
  done: 'bg-green-lightest text-green-darkest',
  ongoing: 'bg-yellow-lightest text-brand-secondary',
  todo: 'bg-grey-lightest text-grey-dark',
};

type Props = {
  label: string;
  state: ChipState;
};

const StationChip = ({ label, state }: Props) => (
  <span
    className={`inline-flex items-center gap-1 text-extra-small font-semibold px-2 py-0.5 rounded-full ${CHIP_CLASSES[state]}`}
  >
    {state === 'done' && <CheckmarkIcon width={10} height={10} />}
    {label}
    {state === 'ongoing' && (
      <span className="kds-chip-dots inline-flex items-center gap-0.5 ml-0.5" aria-hidden="true">
        <span className="w-0.5 h-0.5 rounded-full bg-current opacity-30" />
        <span className="w-0.5 h-0.5 rounded-full bg-current opacity-30" />
        <span className="w-0.5 h-0.5 rounded-full bg-current opacity-30" />
      </span>
    )}
  </span>
);

export default StationChip;
